/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Template_Editor_Category_Statement_TreesInputs */

const en_template_editor_category_statement_trees = /** @type {(inputs: Template_Editor_Category_Statement_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statement trees`)
};

const nl_template_editor_category_statement_trees = /** @type {(inputs: Template_Editor_Category_Statement_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stambomen`)
};

/**
* | output |
* | --- |
* | "Statement trees" |
*
* @param {Template_Editor_Category_Statement_TreesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const template_editor_category_statement_trees = /** @type {((inputs?: Template_Editor_Category_Statement_TreesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Template_Editor_Category_Statement_TreesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_template_editor_category_statement_trees(inputs)
	return en_template_editor_category_statement_trees(inputs)
});